import Vue from "vue";
import Antd from "./ant.js";
Vue.use(Antd);
